<body>
  <app-head></app-head>

  <mat-toolbar color="primary" class="header">
    <mat-toolbar-row>
      <button mat-icon-button (click)="sidenav.toggle()" fxHide fxShow.xs>
          <mat-icon>menu</mat-icon>
      </button>
      <!-- desktop nav -->
      <div fxShow fxHide.xs>
        <ng-container *ngFor="let item of routerLinks">
          <a *ngIf="item.visible" mat-button [routerLink]="item.link" (click)="refreshMarkers()" routerLinkActive="mat-stroked-button" style="padding: 0 23px">
            <span [matBadgeHidden]="!item.marker" matBadgeColor="warn" matBadge="!" matBadgeOverlap="false">{{ item.caption}}</span>
            <!--<span mat-button-wrapper>{{item.caption}}</span>-->
            <div mat-button-focus-overlay></div>
          </a>
        </ng-container>
      </div>
    </mat-toolbar-row>
  </mat-toolbar>

  <mat-sidenav-container class="content">
    <mat-sidenav #sidenav mode="left" class="sidenav">
      <mat-nav-list>
          <!-- mobile nav -->
          <ng-container *ngFor="let item of routerLinks">
            <a *ngIf="item.visible"
              mat-list-item
              routerLinkActive="active"
              [routerLink]="item.link"
              (click)="sidenav.close(); refreshMarkers()">
              <span [matBadgeHidden]="!item.marker" matBadgeColor="primary" matBadge="!" matBadgeOverlap="false">{{ item.caption}}</span>
            </a>
          </ng-container>
      </mat-nav-list>
    </mat-sidenav>

    <lib-toastify-toast-container position="top-right"></lib-toastify-toast-container>

    <router-outlet></router-outlet>
  </mat-sidenav-container>

  <mat-toolbar class="footer" color='primary'>
    <div class='footer-version'>
      <div><a href="https://p24.eu"><img src="./../../assets/img/p24.png" /></a></div>
      <div>CardBro is a brand of P24. All rights reserved by P24 GmbH.</div>
      <span>CardBro v3.0</span>
    </div>
  </mat-toolbar>
</body>
